cbp-grid-item:not([hidden]) {
  display: inherit; 
  position: relative;
  max-width: 100%;
}
